module.exports = __webpack_public_path__ + "static/media/JINGLE_START.f86ba6ab.mp3";